import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { MobileDatePicker } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import axios from "axios";
import moment from "moment";
// import { convertToHTML } from "draft-convert";
// import { EditorState } from "draft-js";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { useRef } from "react";
import { useHistory } from "react-router-dom";
import { io } from "socket.io-client";
import swal from "sweetalert";
import { serverInfo } from "../../../../../../App";
import useFileHandleS3 from "../../../../../../CustomHooks/useFileHandleS3";
import MediaUploadProgressBar from "../../../../../../Screen/MediaUploadProgressBar";
import "./CreateFanGroup.css";

const CreateFanGroup = () => {
  const history = useHistory();
  const [errorList, setError] = useState([]);
  const [loading, setLoading] = useState(false);

  const [dateValue, setDateValue] = useState("");
  const [endDateValue, setEndDateValue] = useState("");
  const [groupName, setName] = useState("");
  const [clubPoints, setClubPoints] = useState("");
  const [minMember, setMinMember] = useState("");
  const [maxMember, setMaxMember] = useState("");
  const [banner, setBanner] = useState("");
  const [showBanner, setShowBanner] = useState("");

  const [convertedContent, setConvertedContent] = useState(null);

   // File Handle
  const [file, setFile] = useState("");
  const [delKey, setDelKey] = useState(null);
  const [fileUrl,fileKey,progress] = useFileHandleS3(file,'fangroup/images',delKey);

  const handleBanner = (file) => {
    setDelKey(fileKey);
    setFile(file[0]);
  };

  useEffect(() => {
    setConvertedContent("");
  }, []);

  const [allStar, setAllStar] = useState([]);
  const [someStar, setSomeStar] = useState([]);

  const [oneStar, setOneStar] = useState("");
  const [twoStar, setTwoStar] = useState("");

  useEffect(() => {
    axios.get("/api/admin/fan-group/star/list").then((res) => {
      if (res.data.status === 200) {
        setAllStar(res.data.allStar);
      }
    });
  }, []);

  const selectStar = (e) => {
    let value = e.target.value;
    var data = value;

    axios.get(`/api/admin/fan-group/star/list/${data}`).then((res) => {
      if (res.status === 200) {
        setSomeStar(res.data.someStar);
      }
      // setLoading(false);
    });

    setOneStar(data);
  };

  const socket = useRef();
  /**
   * socket connection
   */
  const { shoketUrl } = useContext(serverInfo);
  useEffect(() => {
    socket.current = io(shoketUrl);
  }, []);

  const createFanGroup = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();

    formData.append("group_name", groupName);
    formData.append("club_points", clubPoints);
    formData.append("description", convertedContent);

    formData.append(
      "start_date",
      moment(dateValue).format("yyyy-MM-DD HH:mm:ss")
    );
    formData.append(
      "end_date",
      moment(endDateValue).format("yyyy-MM-DD HH:mm:ss")
    );

    formData.append("min_member", minMember);
    formData.append("max_member", maxMember);

    formData.append("my_star", oneStar);
    formData.append("another_star", twoStar);
    formData.append("banner", fileKey);

    axios.post(`/api/admin/fan-group/store`, formData).then((res) => {
      setLoading(false);
      if (res.data.status === 200) {
        setName("");
        setClubPoints("");
        setMinMember("");
        setMaxMember("");
        setConvertedContent("");

        setError([]);

        swal("Welcome", res.data.message, "success");

        history.push("/superstar-admin/pending-fan-group");

        socket.current.emit("fanGroup_approve", {
          id: res.data.fanGroupId,
        });
      } else {
        setError(res.data.validation_errors);

        // error_list: res.data.validation_errors,
      }
    });
  };

  return (
    <div className="AS mb-3">
      <div className="card card-bg head-line mb-2">
        <div className="text-light d-flex justify-content-center p-2">
          <div className="faTrophy">
            <i className="fas fa-trophy"></i>
          </div>
          <h4 className="mx-3 text-white px-2 py-2">Create Fan Group</h4>
        </div>
      </div>

      <div className="card card-bg mb-2 p-2 ">
        <div className="card card-bg m-2">
          <div className="container-lg">
            <div className="row">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                <form onSubmit={createFanGroup}>
                  <div className="row mb-4">
                    <div className="col-md-3 label-text">
                      <p>Group Name</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="text"
                        value={groupName}
                        onChange={(event) => {
                          setName(event.target.value);
                        }}
                        placeholder="Enter fan group name"
                      />
                      {/* <span className="text-danger"> {groupName ? '' : 'Group Name is required'}</span> */}
                      <small className="text-danger validation-warning">
                        {errorList.group_name}
                      </small>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text ">
                      <p>Club Points</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        placeholder="Enter club points"
                        className="form-control reply-control"
                        type="number"
                        value={clubPoints}
                        onChange={(event) => {
                          setClubPoints(event.target.value);
                        }}
                      />
                      {/* <span className="text-danger"> {clubPoints ? '' : 'Club Points is required'}</span> */}
                      <small className="text-danger validation-warning">
                        {errorList.club_points}
                      </small>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Group Motive</p>
                    </div>

                    <div className="col-md-9 ckedittor-fangroup">
                      <CKEditor
                        data={convertedContent}
                        editor={ClassicEditor}
                        onChange={(event, editor) => {
                          setConvertedContent(editor.getData());
                        }}
                      />
                      <small className="text-danger validation-warning">
                        {errorList.description}
                      </small>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text ">
                      <p>Select Date</p>
                    </div>
                    <div className="col-md-9 row">
                      <div className="col-md-5 timeLengthPicker">
                        <input
                          type="date"
                          className="form-control reply-control"
                          onChange={(e) => setDateValue(e.target.value)}
                          name="date"
                          value={dateValue}
                        />
                        <small className="text-danger validation-warning">
                          {errorList.start_date}
                        </small>
                      </div>

                      <div className="col-md-1 d-flex justify-content-center">
                        <span className=" text-warning mt-3">To</span>
                      </div>
                      <div className="col-md-5 timeLengthPicker">
                        <input
                          type="date"
                          className="form-control reply-control"
                          onChange={(e) => setEndDateValue(e.target.value)}
                          name="date"
                          value={endDateValue}
                        />
                        <span className="text-danger">
                          {errorList.end_date}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Members Limit</p>
                    </div>

                    <div className="col-md-9 row  text-warning">
                      <div className="col-md-5">
                        <input
                          placeholder="Enter minimum member"
                          type="number"
                          className="form-control reply-control"
                          value={minMember}
                          onChange={(event) => {
                            setMinMember(event.target.value);
                          }}
                        />
                      </div>
                      <div className="col-md-1 label-text">
                        <span className=" text-warning">To</span>
                      </div>
                      <div className="col-md-5">
                        <input
                          placeholder="Enter maximum member"
                          type="number"
                          className="form-control reply-control"
                          value={maxMember}
                          onChange={(event) => {
                            setMaxMember(event.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>My Star</p>
                    </div>
                    <div className="col-md-6">
                      <select
                        onChange={selectStar}
                        className="form-select form-control reply-control text-black"
                        aria-label="Default select example"
                        id="star_one"
                        name="star_one"
                      >
                        <option value="0">--Select Star--</option>
                        {allStar.map((star, index) => (
                          <option value={star.id}>
                            {star.first_name} {star.last_name}
                          </option>
                        ))}
                      </select>
                      {/* <span className="text-danger">{errorList.my_star}</span> */}
                      <small className="text-danger validation-warning">
                        {errorList.my_star}
                      </small>
                      {/* <span className="text-danger"> {oneStar ? '' : 'Star is required'}</span> */}
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text ">
                      <p>Invite Star</p>
                    </div>
                    <div className="col-md-6">
                      <select
                        className="form-select form-control reply-control text-black"
                        onChange={(event) => {
                          setTwoStar(event.target.value);
                        }}
                        aria-label="Default select example"
                      >
                        <option value="0">--Select Another Star--</option>
                        {someStar.map((star, index) => (
                          <option value={star.id}>
                            {star.first_name} {star.last_name}
                          </option>
                        ))}
                      </select>
                      <small className="text-danger validation-warning">
                        {errorList.another_star}
                      </small>
                      {/* <span className="text-danger"> {twoStar ? '' : 'Another Star is required'}</span> */}
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text ">
                      <p>Upload Banner</p>
                    </div>

                    <div className="col-md-6">
                      {fileUrl ? (
                        <img
                          src={fileUrl}
                          alt="..."
                          className="demo-preview-image img-fluid"
                        />
                      ) : (
                        ""
                      )}
                      <input
                        type="file"
                        className="form-control reply-control"
                        onChange={(e) => handleBanner(e.target.files)}
                      />
                       {file && !fileUrl && <MediaUploadProgressBar progress={progress} />}
                      <small className="text-danger validation-warning">
                        {errorList.banner}
                      </small>
                    </div>
                  </div>

                  {/* Create Submit */}
                  <div className="row justify-content-center aligns-items-center my-4 mt-5">
                    <div className="col-md-3"></div>
                    <div className="col-md-9 d-flex justify-content-center aligns-items-center">
                      {loading ? (
                        <>
                          <button className="btn btnCreate">
                            <i className="fas fa-spinner fa-pulse"></i>{" "}
                          </button>
                        </>
                      ) : (
                        <button className="btn btnCreate fw-bold" type="submit">
                          Save
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Create Submit End */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateFanGroup;
